import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'chameleon/ui-stack/ui/base/icon';

const RightContentLayout = ({ children, showIcon, label, title, icon }) => {
  return (
    <div className="desktop:w-2/6 flex flex-row pb-5 mobile:border-b mobile:border-gray-400 mobile:ml-4">
      <div className="flex flex-col">
        <div className="flex flex-row items-center desktop:mb-6 pt-6">
          <div className="mx-4.6">
            {showIcon && (
              <Icon
                id={icon}
                width="48"
                height="48"
                accessibility={{ ariaHidden: true }}
              />
            )}
            {label}
          </div>
          <div className="font-medium my-6">{title}</div>
        </div>
        {children}
      </div>
    </div>
  );
};

RightContentLayout.propTypes = {
  showIcon: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

RightContentLayout.defaultProps = {
  label: '',
};

export default RightContentLayout;
